import { connect, mapProps, mapReadPretty, ReactFC, useForm, useFormEffects} from '@formily/react'
import { onFormReact, onFormValuesChange } from '@formily/core'
import React, { useCallback, useState, useEffect } from 'react'
import { withContainer } from '../../common/Container'
import './styles.less'
import { compareCase } from '../../../../Formily/service/utils';
export const Box = ({ children, visibleControl, style, ...props}: any) => {
  const form = useForm();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if(visibleControl) {
      if(anyConditionTrue()) {
        setVisible(false)
      } else {
        setVisible(true)
      }
    }
  }, [visibleControl])
  const anyConditionTrue = useCallback(() => {
    if (!visibleControl) return false;
    const anyCondition = visibleControl.caseAction.some(item => {
      const caseDetail = item.caseDetail ? item.caseDetail[0] : undefined;
      if(!caseDetail) return false;
      const result = caseDetail.depsType == 'Switch' ? caseDetail.resultBol : caseDetail.resultStr;
      const fieldState = form.getFieldState(caseDetail.deps) || undefined;
      if(!fieldState) return false;
      const depsValue = caseDetail.depsType == 'Switch' ? Boolean(fieldState[caseDetail.propetry]) : fieldState[caseDetail.propetry];
      const reson = compareCase(depsValue, result, caseDetail.compare)
      return reson;
    })
    return anyCondition
   }, [visibleControl, form])

  useFormEffects(() => {
    onFormValuesChange (() => {
      if(anyConditionTrue()) {
        setVisible(false)
      } else {
        setVisible(true)
      }
    })
  })
 
  return <div className='fromily-box' {...props} style={{ ...style, display: visible ? style?.display : 'none' }} >{children}</div>
}

const FBox =  ({children, ...props}: any) => {
  return <div className='fromily-box' {...props} >{children}</div>
}

const FormilyBox: ReactFC<any> = withContainer(FBox)

export default FormilyBox
